import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bool, func } from 'prop-types'
import AddressPlaceHolder from './AddressPlaceHolder'
import AddressSearch from '../../PlacesAutoComplete'
import { updateShowAddressSearch } from '../../../store/Actions/UiActions'

class InputShow extends Component {
  handleKeyPress = e => {
    if (e.key === 'Enter') {
      this.props.toggleInputBox(true)
    }
  }

  render() {
    let { showAddressSearch, toggleInputBox } = this.props
    return (
      <div
        className="search-click-area"
        onClick={() => toggleInputBox(true)}
        tabIndex="2"
        onKeyPress={e => this.handleKeyPress(e)}
        alt="click to display input box"
      >
        {!showAddressSearch ? <AddressPlaceHolder /> : <AddressSearch />}
      </div>
    )
  }
}

InputShow.propTypes = {
  showAddressSearch: bool.isRequired,
  toggleInputBox: func.isRequired,
}

const mapStateToProps = ({ ui }) => ({
  showAddressSearch: ui.showAddressSearch,
})

const mapDispatchToProps = dispatch => ({
  toggleInputBox: data => dispatch(updateShowAddressSearch(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(InputShow)



// WEBPACK FOOTER //
// ./src/components/Elements/AddressBar/InputShow.jsx